import { Check, Danger, Information } from '@randstad-lean-mobile-factory/react-assets/dist/icons';
import classnames from 'classnames';
import { useMemo } from 'react';

import styles from './Alert.module.scss';
import { AlertProps } from './Alert.types';

export const Alert = ({ variant, icon, className, children, ...props }: AlertProps) => {
  const Icon = useMemo(
    () =>
      icon ??
      {
        default: Information,
        error: Danger,
        warning: Danger,
        information: Information,
        success: Check,
      }[variant],
    [icon, variant]
  );

  return (
    <div className={classnames(styles.alert, className, styles[variant])} {...props}>
      <Icon size="medium" />
      <div>{children}</div>
    </div>
  );
};
